// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-gray-900[data-v-24272aa6]{background-color:#151727}.modal-image[data-v-24272aa6]{max-width:77%}.btn-simple[data-v-24272aa6]{background-color:#2a2b3a !important}.btn-simple[data-v-24272aa6]:hover{background-color:#3e3f4c !important}.close[data-v-24272aa6]{font-size:24px}.close[data-v-24272aa6]:not(:hover){opacity:1}@media(max-width: 991.98px){.close[data-v-24272aa6]{position:absolute;top:30px;right:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
